export default {
    API_ENDPOINT: process.env.API_ENDPOINT || 'https://stormy-beyond-18995.herokuapp.com/api',
    EVENTBRITE_API_ENDPOINT: process.env.EVENTBRITE_API_ENDPOINT || 'http://localhost:8001/api',
    REACT_APP_TOKEN_KEY: process.env.REACT_APP_TOKEN_KEY || 'jobReel-jwt-secret',
  }
  